import { AlbumResponse } from '@klubovna/api-client';
import { createReducer, on } from '@ngrx/store';
import * as AlbumsActions from './albums.actions';
import { initialAlbumsState } from './albums.state';

export const albumsReducer = createReducer(
  initialAlbumsState,
  on(AlbumsActions.loadAlbums, (state, { params }) => ({
    ...state,
    query: {
      ...state.query,
      ...params,
      page: 1,
      limit: params?.limit ?? state.limit,
    },
    loading: true,
    error: null,
  })),
  on(AlbumsActions.loadAlbumsSuccess, (state, { response }) => ({
    ...state,
    albums: response.items.filter((album: AlbumResponse) => album.isActive),
    total: response.total,
    page: response.page,
    limit: response.limit,
    hasMore: response.page < response.totalPages,
    loading: false,
    error: null,
  })),
  on(AlbumsActions.loadAlbumsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(AlbumsActions.loadMoreAlbums, (state) => ({
    ...state,
    loadingMore: true,
    error: null,
  })),
  on(AlbumsActions.loadMoreAlbumsSuccess, (state, { response }) => ({
    ...state,
    albums: [ ...state.albums, ...response.items.filter((album: AlbumResponse) => album.isActive) ],
    total: response.total,
    page: response.page,
    hasMore: response.page < response.totalPages,
    loadingMore: false,
    error: null,
  })),
  on(AlbumsActions.loadMoreAlbumsFailure, (state, { error }) => ({
    ...state,
    loadingMore: false,
    error,
  })),
  on(AlbumsActions.loadAlbumBySlug, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(AlbumsActions.loadAlbumById, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(AlbumsActions.loadAlbumSuccess, (state, { album }) => ({
    ...state,
    selectedAlbum: album,
    loading: false,
    error: null,
  })),
  on(AlbumsActions.loadAlbumFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(AlbumsActions.clearSelectedAlbum, (state) => ({
    ...state,
    selectedAlbum: null,
  })),
  on(AlbumsActions.resetAlbums, () => initialAlbumsState),
);
